import React, { FunctionComponent, useEffect } from "react";

import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import {
  fetchCategories,
  selectCategories,
  selectCategoriesDict,
} from "../../features/category/categorySlice";
import {
  selectAreCoursesFetching,
} from "../../features/courses/coursesSlice";
import { MainLayout } from "../common/Layouts/Main";
import { CoursesForm } from "./Form";
import { Prefixes } from "../prefixes";
import { getTranslations } from "../../features/translations/translationsUtils";

export const EditCourse: FunctionComponent = () => {
  const match = useRouteMatch();
  const areCoursesFetching = useSelector(selectAreCoursesFetching);
  const categories = useSelector(selectCategoriesDict);
  const categoriesIds = useSelector(selectCategories);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!areCoursesFetching) {
      form.setFieldsValue({});
      form.resetFields();
    }
  }, [form, areCoursesFetching]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  return (
    <MainLayout
      hideTitle={false}
      title={getTranslations('COURSE_EDIT')}
      onGoBack={() => {
        history.push(`${Prefixes.course}`);
      }}
      breadcrumbs={[getTranslations('COURSE_TITLE'), getTranslations('COURSE_EDIT')]}
    >
      <CoursesForm
        categories={categories}
        categoriesIds={categoriesIds}
        editing={(match.params as any).id!}
        form={form}
      />
    </MainLayout>
  );
};
